import { perfilMarca } from '@aosenuma/lib-types';
import { Logo } from '@aosenuma/ui';

export function BrandMark() {
  const marca = perfilMarca();
  return (
    <div className="brand-mark">
      {/* En modo presentación el bloque se queda solo con el texto, que ya es
          neutro por sí mismo — no hace falta sustituto para el logo. */}
      {!marca.neutral && (
        <>
          <Logo variant="elawan" height={32} />
          <div className="brand-divider" />
        </>
      )}
      <div className="brand-text">
        <strong>aosenumareport</strong> <span>· Sistema de Inteligencia Territorial</span>
      </div>
    </div>
  );
}
